import AppButton from "../../../ui/buttons/AppButton";
import DropdownChevron from "../../../ui/overlays/DropdownChevron";
import MenuButton from "../../../ui/overlays/MenuButton";

export interface ActionMenuItem {
  readonly id: string;
  readonly label: string;
  readonly onSelect: () => void;
  readonly disabled?: boolean;
  /** Why it can't be chosen now (P-B): it stays in the menu and says so. */
  readonly unavailable?: string;
}

interface ActionMenuProps {
  /** The button's text, and the menu's accessible name. */
  label: string;
  items: readonly ActionMenuItem[];
}

/** The Thread page's "More" menu: the shared menu button with a labelled trigger. */
export default function ActionMenu({ label, items }: ActionMenuProps) {
  return (
    <MenuButton
      sections={[
        {
          id: "actions",
          items: items.map((item) => ({
            id: item.id,
            label: item.label,
            disabled: item.disabled,
            unavailable: item.unavailable,
            action: { kind: "select", onSelect: item.onSelect },
          })),
        },
      ]}
      renderTrigger={(trigger, open) => (
        <AppButton {...trigger} variant="secondary" size="sm">
          {label}
          <DropdownChevron open={open} />
        </AppButton>
      )}
    />
  );
}
